export const UserPlus = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="9" r="6" stroke="currentColor" stroke-width="2"/>
<path d="M3 30V25C3 21.6863 5.68629 19 9 19H15C18.3137 19 21 21.6863 21 25V30" stroke="currentColor" stroke-width="2"/>
<path d="M27 10V20" stroke="currentColor" stroke-width="2"/>
<path d="M32 15L22 15" stroke="currentColor" stroke-width="2"/>
</svg>`;
